export default __webpack_public_path__ + "static/fold-d4ec110a36d5d83004de0f6099c4c1c2.png";